import { Container } from '@mui/material';
import { NavLink } from "react-router-dom";

import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import BatchAddForm from '../../forms/batchAddForm';
import { Icons } from '../../icons';

const BatchAdd = () => {
	const userContext = useUserContext();

	return (
		<div className="hwi-load-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageShipments}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/batch">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Batch
						</div>
					</section>
					<section className="management-page-form">
						<BatchAddForm></BatchAddForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default BatchAdd;